import React, { ForwardRefExoticComponent, forwardRef } from 'react'
import { Linking, Platform, TextProps, ViewProps } from 'react-native'
import { View, Text } from 'dripsy'
import Press from '../press'

export type LinkProps = React.PropsWithChildren<
  Omit<TextProps, 'ref'> & {
    /** @platform web */
    href?: string
    /** @platform web */
    target?: '_blank'
    disableOnNative?: boolean
    /** @platform web */
    rel?: string
    /** @platform web */
    hrefAttrs?: {
      target?: string
      rel?: string
    }
  }
>

const A = forwardRef(function A(
  {
    href,
    target,
    isText = true,
    disableOnNative = false,
    ...props
  }: Omit<LinkProps, 'hrefAttrs'> & { isText?: boolean },
  ref?: any
) {
  const nativeProps = Platform.select<
    LinkProps & { hrefAttrs?: { href?: string; target?: string; rel?: string } }
  >({
    web: {
      href,
      // target,
      hrefAttrs: {
        // href,
        target: target?.replace('_', ''), // patch old RNW
        rel: 'noopener',
      },
      // rel: 'noopener',
    },
    default: {
      onPress: (event) => {
        props.onPress?.(event)
        if (href !== undefined && !disableOnNative) {
          Linking.openURL(href)
        }
      },
    },
  })
  const Component = isText
    ? Text
    : Platform.select({ web: View, default: Press as any })
  return (
    <Component
      accessibilityRole="link"
      {...props}
      {...nativeProps}
      ref={ref as any}
    />
  )
}) as ForwardRefExoticComponent<LinkProps & { isText?: boolean; ref: any }>

export default A
